module.exports = __webpack_public_path__ + "8e05ea9d95d0dce10ad2c92737ef12dc.svg";